export const GET_DATA = 'html/GET_DATA';
export const SET_DATA = 'html/SET_DATA';
export const SET_STATUS = 'html/SET_STATUS';
